/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Drawer, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { SearchArea } from '@msdyn365-commerce/retail-proxy';
import { IDXC_StoreLocations } from '../../data-actions/generated/DataServiceEntities.g';
import { getStoreLocationsAction, GetStoreLocationsInput } from '../../data-actions/store-locations/get-store-locations';
import { ICittaStoreLocationsV2Data } from './citta-store-locations-v2.data';
import { ICittaStoreLocationsV2Props } from './citta-store-locations-v2.props.autogenerated';


interface ICittaStoreLocationsState {
    storeCategoryId: string;
    stores: IDXC_StoreLocations[] | undefined;
    // openFirstDrawerComp: boolean;
}
export interface ICittaStoreLocationsV2ViewProps extends ICittaStoreLocationsV2Props<ICittaStoreLocationsV2Data> {
    CittaStoresShow: boolean;
    CittaStores: IModuleProps;
    StoreTypeHeading: INodeProps;
    StoreHeadingLabel: INodeProps;
    StoreHeadingLabelValue: string;
    CittaStoreLocations: INodeProps;
    CittaStoresList: React.ReactNode;
    ViewStoresToggle: INodeProps;
    ToggleStoreName: React.ReactNode;
}

/**
 *
 * CittaStoreLocationsV2 component
 * @extends {React.PureComponent<ICittaStoreLocationsV2Props<ICittaStoreLocationsV2Data>>}
 */
class CittaStoreLocationsV2 extends React.PureComponent<ICittaStoreLocationsV2Props<ICittaStoreLocationsV2Data>, ICittaStoreLocationsState> {

    private resources = {
        store_stockistOfHeading: this.props.resources.store_stockistOfHeading || 'Stockists of',
        store_storeHoursHeading: this.props.resources.store_storeHoursHeading || 'Store Hours',
        store_storeHoursMonday: this.props.resources.store_storeHoursMonday || 'Monday',
        store_storeHoursTuesday: this.props.resources.store_storeHoursTuesday || 'Tuesday',
        store_storeHoursWednesday: this.props.resources.store_storeHoursWednesday || 'Wednesday',
        store_storeHoursThursday: this.props.resources.store_storeHoursThursday || 'Thursday',
        store_storeHoursFriday: this.props.resources.store_storeHoursFriday || 'Friday',
        store_storeHoursSaturday: this.props.resources.store_storeHoursSaturday || 'Saturday',
        store_storeHoursSunday: this.props.resources.store_storeHoursSunday || 'Sunday',
        store_storeHoursClosed: this.props.resources.store_storeHoursClosed || 'Closed',
        // citta_store_image_hero: [
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',
        //     'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3M89?pubver=1',

        // ]
    };


    constructor(props: ICittaStoreLocationsV2Props<ICittaStoreLocationsV2Data>) {
        super(props);
        this.state = {
            storeCategoryId: '',
            stores: [],
            // openFirstDrawerComp: false
        };
        this._changeStoreCategoryItem = this._changeStoreCategoryItem.bind(this);
    }

    public async componentDidMount(): Promise<void> {
        const inputObj: SearchArea = {};
        if (navigator && navigator.geolocation) {
            // tslint:disable-next-line: no-this-assignment
            const that = this;
            navigator.geolocation.getCurrentPosition(
                position => {
                    inputObj.Latitude = position.coords.latitude ? position.coords.latitude : 0; // -36.84403
                    inputObj.Longitude = position.coords.longitude ? position.coords.longitude : 0; // 174.76008
                    inputObj.Radius = 2000; // position.coords.accuracy;
                    inputObj.DistanceUnitValue = 0; // position.coords.altitudeAccuracy!;
                    // tslint:disable-next-line: no-floating-promises
                    getStoreLocationsAction(new GetStoreLocationsInput(inputObj), this.props.context.actionContext).then(
                        (result) => {
                            this.setState({
                                // stores: result.nearMeStoreLocations && result.nearMeStoreLocations.length > 0 ? result.nearMeStoreLocations.filter(item =>item.storName !== "Città Newmarket") : result.storeLocations?.filter(item =>item.storName !== "Città Newmarket")
                                stores: result.nearMeStoreLocations && result.nearMeStoreLocations.length > 1 ? result.nearMeStoreLocations.filter(item =>item.storName !== "Città Newmarket") : storeLocationsBackUp
                            });
                        });
                },
                error => {
                    if (error.code === error.PERMISSION_DENIED) {
                        inputObj.Latitude = 0; // -36.84403
                        inputObj.Longitude = 0; // 174.76008
                        inputObj.Radius = 2000; // position.coords.accuracy;
                        inputObj.DistanceUnitValue = 0; // position.coords.altitudeAccuracy!;
                        getStoreLocationsAction(new GetStoreLocationsInput(inputObj), that.props.context.actionContext).then(
                            (result) => {
                                that.setState({
                                    stores:  result.storeLocations && result.storeLocations.length > 1 ? result.storeLocations?.filter(item =>item.storName !== "Città Newmarket") : storeLocationsBackUp
                                });
                            })
                            .catch(() => {
                                console.log('No data');
                            });
                    }
                });
        }
    }


    public render(): JSX.Element | null {

        const CittaStoreLocationsViewProps = {
            ...this.props,
            CittaStores: {
                moduleProps: this.props,
                className: 'citta-stores'
            },
            StoreTypeHeading: {
                className: 'store-type-heading'
            },
            StoreHeadingLabel: {
                className: 'store-heading-label',
                tag: 'p'
            },
            CittaStoreLocations: {
                className: 'citta-store-locations',
                role: 'menu'
            },
            CittaStoresList: this._renderStoresList(),
            ViewStoresToggle: {
                className: 'view-stores-toggle'
            },
        };
        return this.props.renderView(CittaStoreLocationsViewProps);
    }


    private _renderStoresList(): React.ReactNode { 
        return (this.state.stores && this.state.stores.map((child: IDXC_StoreLocations, index: number) => {

            const streetaddress: '' | string[] | undefined = child.address && child.address.split('\n');
            if (streetaddress) {
                streetaddress.pop();
                if (streetaddress.length < 4) {
                    streetaddress.push('NZL')
                }
            }
            const stockistsOf: '' | string[] | undefined = child.stockistOf && child.stockistOf.split('\n');
            const stockistOfStr: '' | string | undefined = stockistsOf && stockistsOf.join(", ");

            const storemainimage: '' | string | undefined = this.props.config.storeMainImage.find(storemainImageString => storemainImageString.startsWith(child.storName || 'undefined'));
            const storedetailimageleft: '' | string | undefined = this.props.config.storeDetailImageLeft.find(storeDetailImageLeft => storeDetailImageLeft.startsWith(child.storName || 'undefined'));
            const storedetailimageright: '' | string | undefined = this.props.config.storeDetailImageRight.find(storeDetailImageRight => storeDetailImageRight.startsWith(child.storName || 'undefined'));
            const googlemaplink: '' | string | undefined = this.props.config.googleMapLink.find(googleMapLink => googleMapLink.startsWith(child.storName || 'undefined'));
            const storelink: '' | string | undefined = this.props.config.storeLink.find(storeLink => storeLink.startsWith(child.storName || 'undefined'));
            const storeHoursMondayBackUp: '' | string | undefined = this.props.config.storeHoursMondayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursTuesdayBackUp: '' | string | undefined = this.props.config.storeHoursTuesdayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursWednesdayBackUp: '' | string | undefined = this.props.config.storeHoursWednesdayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursThursdayBackUp: '' | string | undefined = this.props.config.storeHoursThursdayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursFridayBackUp: '' | string | undefined = this.props.config.storeHoursFridayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursSaturdayBackUp: '' | string | undefined = this.props.config.storeHoursSaturdayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            const storeHoursSundayBackUp: '' | string | undefined = this.props.config.storeHoursSundayBackUp?.find(str => str.startsWith(child.storName || 'undefined'));
            return (
                <div className='citta-store-1 col-sm-12 col-md-4 col-lg-4 col-xl-4' key={index}>
                    <div className='store-locations-hero'>
                        {/* <img src={this.resources.citta_store_image_hero[index]} alt="" /> */}
                        <img src={storemainimage?.split('|')[1]} alt="" />
                    </div>

                    <div className='store-locations-title'>
                        {child.storName}
                    </div>

                    <div className='store-locations-address-main' id={`${child.storName}${index}`}>
                        {streetaddress && streetaddress.map((addressline: string, indexadd: number) =>
                        (<div className={addressline === 'NZL' ? `citta-store-address-NZL` : `citta-store-address-${indexadd}`} key={indexadd}>
                            {addressline}
                        </div>
                        ))}
                    </div>

                    <div className="citta-store-mobile-button">
                        <a href={storelink?.split('|')[1]}>MORE INFO &gt;</a>
                        {/* <a >MORE INFO &gt;</a> */}
                    </div>

                    <Drawer
                        toggleButtonText='Store hours and contact information'
                        openGlyph={'fa fa-chevron-up'}
                        closeGlyph={'fa fa-chevron-down'}
                        glyphPlacement={'end'}
                        collapseProps={{
                            timeout: -1,
                            isOpen: (this.state.storeCategoryId === (child && child.storName || '') + index) ? true : false
                        }}
                        onToggle={() => (this._changeStoreCategoryItem((child && child.storName || '') + index))}
                    >

                        <>
                            <div className='row citta-store-drawer' style={{ marginLeft: `calc(-${(index % 3)}00% - ${(index % 3)}*15px)` }}  >
                                <div className='col-12'>
                                    <div className='citta-store-drawer-back'> <a onClick={() => this._changeStoreCategoryItem((child && child.storName || '') + index)}></a></div>
                                </div>
                                <div className='citta-store-location-left col-sm-5 col-md-5 col-lg-5 col-xl-5'>
                                    <div className='store-locations-name'>
                                        {child.storName}
                                    </div>
                                    <br />
                                    <div className='store-locations-address'>
                                        {streetaddress && streetaddress.map((addressline: string, indexadd: number) =>
                                        (
                                            <div className={`citta-store-address-${indexadd}`} key={indexadd}>
                                                {addressline}
                                            </div>
                                        ))}


                                        <div className='citta-store-phone'>
                                            <p className='citta-store-phone-text'>phone:</p>
                                            <a className='citta-store-phone-number' href={`tel:${child.phone}`}>{child.phone}</a>
                                        </div>
                                        <div className='citta-store-email'>
                                            <p>email:</p>
                                            <a className='citta-store-email-link' href={`mailto:${child.emailAddress}`}>{child.emailAddress}</a>
                                        </div>

                                        <div className='citta-store-storeHours' >
                                            <div className='citta-store-storeHours-heading'>
                                                {this.resources.store_storeHoursHeading}
                                            </div>
                                            {child && child.storeHours && this._renderStore(storeHoursMondayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnMonday!, this.resources.store_storeHoursMonday, Number(storeHoursMondayBackUp?.split('|')[2])*3600 || child.storeHours.MondayOpenTime!, Number(storeHoursMondayBackUp?.split('|')[3])*3600 || child.storeHours.MondayCloseTime!, storeHoursMondayBackUp?.split('|')[4] || '')}
                                            {child && child.storeHours && this._renderStore(storeHoursTuesdayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnTuesday!, this.resources.store_storeHoursTuesday, Number(storeHoursTuesdayBackUp?.split('|')[2])*3600 || child.storeHours.TuesdayOpenTime!, Number(storeHoursTuesdayBackUp?.split('|')[3])*3600 || child.storeHours.TuesdayCloseTime!, storeHoursTuesdayBackUp?.split('|')[4] || '' )}
                                            {child && child.storeHours && this._renderStore(storeHoursWednesdayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnWednesday!, this.resources.store_storeHoursWednesday, Number(storeHoursWednesdayBackUp?.split('|')[2])*3600 || child.storeHours.WednesdayOpenTime!, Number(storeHoursWednesdayBackUp?.split('|')[3])*3600 || child.storeHours.WednesdayCloseTime!, storeHoursWednesdayBackUp?.split('|')[4] || '')}
                                            {child && child.storeHours && this._renderStore(storeHoursThursdayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnThursday!, this.resources.store_storeHoursThursday, Number(storeHoursThursdayBackUp?.split('|')[2])*3600 || child.storeHours.ThursdayOpenTime!, Number(storeHoursThursdayBackUp?.split('|')[3])*3600 || child.storeHours.ThursdayCloseTime!, storeHoursThursdayBackUp?.split('|')[4] || '')}
                                            {child && child.storeHours && this._renderStore(storeHoursFridayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnFriday!, this.resources.store_storeHoursFriday, Number(storeHoursFridayBackUp?.split('|')[2])*3600 || child.storeHours.FridayOpenTime!, Number(storeHoursFridayBackUp?.split('|')[3])*3600 || child.storeHours.FridayCloseTime!, storeHoursFridayBackUp?.split('|')[4] || '')}
                                            {child && child.storeHours && this._renderStore(storeHoursSaturdayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnSaturday!, this.resources.store_storeHoursSaturday, Number(storeHoursSaturdayBackUp?.split('|')[2])*3600 || child.storeHours.SaturdayOpenTime!, Number(storeHoursSaturdayBackUp?.split('|')[3])*3600 || child.storeHours.SaturdayCloseTime!, storeHoursSaturdayBackUp?.split('|')[4] || '')}
                                            {child && child.storeHours && this._renderStore(storeHoursSundayBackUp?.split('|')[1] === "true" || child.storeHours.IsClosedOnSunday!, this.resources.store_storeHoursSunday, Number(storeHoursSundayBackUp?.split('|')[2])*3600 || child.storeHours.SundayOpenTime!, Number(storeHoursSundayBackUp?.split('|')[3])*3600 || child.storeHours.SundayCloseTime!, storeHoursSundayBackUp?.split('|')[4] || '')}
                                        </div>

                                        <div className='citta-store-stockistsof'>
                                            <div className='citta-store-stockistsof-content'>
                                                <div>
                                                    {`Our ${child.storName} store stocks ${stockistOfStr}.`}

                                                </div>
                                            </div>
                                        </div>
                                        <div className='citta-store-location-notes'>
                                            {child.locationNotes}
                                        </div>
                                    </div>
                                    <div className="citta-store-location-end">
                                        <p>{(child.storName === "Città Essentials Wellington" || child.storName === "Città Newmarket") ? null : "Click & collect available during store hours."}</p>
                                    </div>
                                </div>
                                <div className='citta-store-location-right col-sm-7 col-md-7 col-lg-7 col-xl-7' >
                                    <div className='citta-store-location-right-images row'>
                                        <div className="citta-store-location-right-images-1 img-fluid col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <img src={storedetailimageleft?.split('|')[1]} alt="" />
                                            {/* <img src="https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3JwR?pubver=1" alt="" /> */}
                                        </div>
                                        <div className="citta-store-location-right-images-1 img-fluid col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <img src={storedetailimageright?.split('|')[1]} alt="" />
                                            {/* <img src="https://images-ap-prod.cms.commerce.dynamics.com/cms/api/nrrhswtcqq/imageFileData/MB3JwR?pubver=1" alt="" /> */}
                                        </div>
                                    </div>
                                    <div className="citta-store-map">
                                        <div className='citta-store-location-right-map'>
                                            <iframe src={googlemaplink?.split('|')[1]} width="800" height="200" style={{ border: 0 }} ></iframe>
                                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.8877115427063!2d174.76203821582018!3d-36.86910648835239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d47dae79d382d%3A0xd2e1ce192db25018!2s20%20Normanby%20Road%2C%20Mount%20Eden%2C%20Auckland%201024!5e0!3m2!1sen!2snz!4v1675988229806!5m2!1sen!2snz" width="800" height="200" style={{ border: 0 }} ></iframe> */}
                                        </div>
                                        <div>
                                            <a className='citta-store-map-link' href={child && child.googleMapLink ? child.googleMapLink : '#'} target='_blank'>Get directions &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="citta-store-drawer-background" style={{ marginLeft: `calc(-${(index % 3)}00% - ${(index % 3)}*15px)` }} ></div>

                        </>
                    </Drawer>
                    <br />
                </div>
            );
        }));
    }

    private _renderStore(isClosed: boolean, day: string, openTime: number, closeTime: number, holiday: string): JSX.Element | null {
        const openFrom: string | undefined = this._secondsToTime(openTime);
        const openTo: string | undefined = this._secondsToTime(closeTime);
        return (
            <div>
                {isClosed ?
                    <div className='citta-store-storeHours-content'>
                        <div className='citta-store-storeHours-content-day'> {day}</div>
                        <div className='citta-store-storeHours-content-hours'>{this.resources.store_storeHoursClosed} {holiday}</div>
                    </div> :
                    <div className='citta-store-storeHours-content'>
                        <div className='citta-store-storeHours-content-day'> {day}</div>
                        <div className='citta-store-storeHours-content-hours'>{openFrom} - {openTo} {holiday}</div>
                    </div>}
            </div>
        );
    }

    private _secondsToTime = (seconds: number | undefined): string | undefined => {
        if (seconds === undefined) {
            return undefined;
        } else {
            let hours = Math.floor(seconds / (60 * 60));
            const ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12;
            const divisorForMinutes = seconds % (60 * 60);
            const minutes =
                Math.floor(divisorForMinutes / 60) < 10 ? `0${Math.floor(divisorForMinutes / 60)}` : Math.floor(divisorForMinutes / 60);
            return `${hours}.${minutes} ${ampm}`;
        }
    };

    private _changeStoreCategoryItem(storeCategoryId: string): any {
        if (this.state.storeCategoryId !== storeCategoryId) {
            this.setState({ storeCategoryId: storeCategoryId });

            // document.getElementById(storeCategoryId)?.scrollIntoView({behavior: "smooth", block: "start"})
            setTimeout(() => document.getElementById(storeCategoryId)?.scrollIntoView({ behavior: "smooth", block: "start" }), 30)
        } else {
            this.setState({ storeCategoryId: '' });
            document.getElementById(storeCategoryId)
        }
    }

}

let storeLocationsBackUp  : IDXC_StoreLocations[] | undefined = [
    {
        storName: "Città BLOC",
        address: `BLOC, Level 1
        20 Normanby Road
        Mount Eden
        Auckland 1024
        NZL`,
        phone: "09 929 1617",
        emailAddress: "mteden@cittadesign.com",
        locationNotes:"*Customer parking off Enfield Street",
        stockistOf:`Anglepoise
        Artek
        Città
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/hX8WfZUAsjDmA7E16",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 32400,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
     },
     {
        storName: "Città Essentials Mount Eden",
        address: `18 Normanby Road
        Mount Eden
        Auckland 1024
        NZL`,
        phone: "09 623 9882",
        emailAddress: "mteden@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/9WpVnGqMksTDA2516",
        storeHours:{
         MondayOpenTime: 36000,
         MondayCloseTime: 57600,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 36000,
         TuesdayCloseTime: 57600,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 36000,
         WednesdayCloseTime: 57600,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 36000,
         ThursdayCloseTime: 57600,
         IsClosedOnThursday: false,
         FridayOpenTime: 36000,
         FridayCloseTime: 57600,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 57600,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Grey Lynn",
        address: `Westmoreland Shops
        274 Richmond Road (access from Westmoreland St West)
        Grey Lynn
        Auckland 1021
        NZL`,
        phone: "09 972 9293",
        emailAddress: "greylynn@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Asili
        Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Korbo
        Nodi
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://maps.app.goo.gl/LDQZPuUdg4gmXiDeA",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Hamilton",
        address: `Made Hamilton
        401 Grey Street
        Hamilton East
        Hamilton 3216
        NZL`,
        phone: "07 929 4027",
        emailAddress: "hamilton@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Asili
        Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Korbo
        Nodi
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://maps.app.goo.gl/83bepS4QX2V8RMf9A",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 32400,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 32400,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Takapuna",
        address: `Shop 2, 6/8 Como Street
        Takapuna
        Auckland 0622
        NZL`,
        phone: "09 972 9147",
        emailAddress: "takapuna@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Città
        Città Essentials
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/S534kU3XiZNmi9vDA",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Essentials North Shore",
        address: `7D Triton Drive
        Albany
        Auckland 0632
        NZL`,
        phone: "09 478 9994",
        emailAddress: "northshore@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/ow3tmtT36r6K83gQ7",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Essentials Wellington",
        address: `11 College Street
        Te Aro
        Wellington 6011
        NZL`,
        phone: "04 385 6398",
        emailAddress: "wellington@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Our College Street store is dedicated to Città Essentials products. We also stock designs from our Cushion Archive`,
        googleMapLink: "https://goo.gl/maps/6aek1HyLKLdynJ8b7",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 61200,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 61200,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 61200,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 61200,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 61200,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 61200,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Wellington Thorndon",
        address: `Woolstore Design Centre
        258 Thorndon Quay
        Pipitea
        Wellington 6011
        NZL`,
        phone: "04 473 7075",
        emailAddress: "thorndon@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Città
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/6pht3DrDQVRW2myS7",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
     {
        storName: "Città Essentials Christchurch",
        address: `752 Main North Road
        Belfast
        Christchurch 8052
        NZL`,
        phone: "03 323 9878",
        emailAddress: "christchurch@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/hWL4apQ77GvGtnz59",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Merivale",
        address: `12 Papanui Road
        Merivale
        Christchurch 8014
        NZL`,
        phone: "03 595 0482",
        emailAddress: "merivale@cittadesign.com",
        locationNotes:"*Customer parking off Derby Street",
        stockistOf:`Artek
        Città
        Città Essentials
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/FonTM2TCBckA6Z5b8",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Essentials Glen Innes",
        address: `117 Apirana Avenue
        Glen Innes
        Auckland 1072
        NZL`,
        phone: "09 255 1525",
        emailAddress: "gleninnes@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/81VzLgtFLgBfeBCp9",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      }
 ];

export default CittaStoreLocationsV2;
